import {ImgHTMLAttributes} from 'react'

export default function ApplicationLogo(props: ImgHTMLAttributes<HTMLImageElement>) {
  return (
    <img {...props} src={'https://profilii.hu/wp-content/themes/profilii/includes/img/pro_filii_logo.png'}
         alt={"Profilii Alapítvány Logo"}/>
  )
}
